import React from "react";
import cx from "classnames";
//
import { formatMoney, getHumanDuration } from "../utils";

const PriceRecap = ({
  currency,
  discount,
  isPremium,
  model,
  modelRate,
  duration,
  locationFee,
  services,
  total,
}) => {
  const _duration = getHumanDuration(duration);

  return (
    <table className="summary">
      <tbody>
        <tr>
          <td>
            {model.name} ({_duration})
          </td>
          <td className="summary__add" />
          <td>
            {formatMoney(modelRate.amount)} <small>{currency}</small>
          </td>
          <td />
        </tr>
        {locationFee > 0 && (
          <tr>
            <td>Travel fee</td>
            <td className="summary__add">+</td>
            <td>
              {formatMoney(locationFee)} <small>{currency}</small>
            </td>
            <td />
          </tr>
        )}
        {services.map((_serv) => {
          const price = _serv.multiplier
            ? _serv.multiplier * modelRate.amount
            : _serv.price;

          return (
            <tr key={_serv.id}>
              <td>{_serv.name}</td>
              <td className="summary__add">+</td>
              <td>
                {formatMoney(price)} <small>{currency}</small>
              </td>
              <td />
            </tr>
          );
        })}
        {discount > 0 && (
          <tr className={cx({ summary__active: !isPremium })}>
            <td>Discount</td>
            <td className="summary__add">-</td>
            <td>
              <span className={cx({ "u-strike": !isPremium })}>
                {formatMoney(discount)}
              </span>{" "}
              <small>{currency}</small>
            </td>
            <td>
              {!isPremium && (
                <a className="u-link u-small" href="/premium" target="_blank">
                  Buy premium
                </a>
              )}
            </td>
          </tr>
        )}
        <tr className="summary__total">
          <td colSpan="2">Total</td>
          <td>
            {formatMoney(total)} <small>{currency}</small>
          </td>
          <td />
        </tr>
      </tbody>
    </table>
  );
};

export default PriceRecap;
